import React from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

import Button from '@/ui/Button/Button';
import { ArrowRight, Basket } from '@/icons/index';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';
import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import { Bag } from '@/icons/section';

import style from './Products.module.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ProductItem = ({
  product: {
    images = [],
    name = '',
    price = '',
    description = '',
    discount = '',
  },
}) => {
  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,

    customPaging: (dots) => (
      <div className={style.dots}>
        <div className={style.invisible}>{dots}</div>
      </div>
    ),

    swipe: true,
    swipeToSlide: false,
    touchMove: false,
    draggable: true,
  };

  const renderImages = (image, key) => (
    <div
      className={style.imageContainer}
      key={key}
      itemScope
      itemType='https://schema.org/ImageObject'
    >
      <Image src={image} alt={name} title={name} loading='lazy' layout='fill' />
    </div>
  );

  return (
    <div
      className={style.item}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      {!!images.length && (
        <div className={style.imagesWrapper}>
          <Slider
            {...settings}
            className={`product-slider ${style.imagesSlider}`}
          >
            {images.map(renderImages)}
          </Slider>
        </div>
      )}
      {!!discount && (
        <button aria-label={discount} className={style.discount}>
          {discount}
        </button>
      )}
      <div className={style.bottomWrapper}>
        <div className={style.own_info}>
          <span className={style.name}> {name} </span>
          <span className={style.price}> {price} $</span>
        </div>
        <span className={style.description}> {description} </span>
        <div className={style.bottomWrapper__btns}>
          <Button aria-label='Bakcell' className={style.buy}>
            Buy now <ArrowRight width={20} />
          </Button>
          <button className={style.basket}>
            <Basket />
          </button>
        </div>
      </div>
    </div>
  );
};

const data = [
  {
    images: [
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
    ],
    name: 'Apple Watch',
    price: '5000',
    description:
      'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
    id: 'kjkj',
  },
  {
    images: [
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
    ],
    name: 'Apple Watch',
    price: '5000',
    description:
      'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
    discount: '20% discount',
    id: 'kjkj',
  },
  {
    images: [
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
    ],
    name: 'Apple Watch',
    price: '5000',
    description:
      'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
    id: 'kjkj',
  },
  {
    images: [
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
      '/assets/home/appleWatch.png',
    ],
    name: 'Apple Watch',
    price: '5000',
    description:
      'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
    id: 'kjkj',
  },
];

// products block
const Products = () => {
  const renderItems = (item, index) => {
    return <ProductItem key={index} product={item} />;
  };

  return (
    <div className={'section'} itemScope itemType='https://schema.org/ItemList'>
      <SectionTitle
        Icon={Bag}
        buttonText={'Visit shop'}
        className={'wrapper'}
        href={'/shop'}
        titleModify='title--large'
      >
        Bakcell shop
      </SectionTitle>
      <SliderWrapper>{data.map(renderItems)}</SliderWrapper>
    </div>
  );
};

export default Products;
